<template>
    <div class="form-label-container">
        <label class="form-label" :for="id">
            <slot />
        </label>

        <slot v-if="hasHelp" name="help" />
    </div>
</template>
<script>
export default {
    props: {
        id: {
            type: String,
            default: null,
        },
    },

    computed: {
        /**
         * Indicates whether components has "help" slot.
         *
         * @returns {boolean} Value of computation.
         */
        hasHelp() {
            return !! this.$slots.help;
        },
    },
};
</script>
